import styled, { css } from 'styled-components'

import { BadgeVariant, ContainerProps } from './Badge.types'

const variantStyles = ({ $variant, $backgroundColor, $textColor }: ContainerProps) => {
  switch ($variant) {
    case BadgeVariant.ACCENT:
      return css`
        background-color: ${({ theme: { colors } }) => colors.accent};
      `
    case BadgeVariant.SECONDARY:
      return css`
        background-color: ${({ theme: { colors } }) => colors.secondary};
      `
    case BadgeVariant.PRIMARY:
      return css`
        background-color: ${({ theme: { colors } }) => colors.primary};
      `
    case BadgeVariant.TAG:
      return css`
        background-color: ${$backgroundColor};
        font-size: 12px;
        font-weight: 400;
        color: ${$textColor};
        min-width: ${$backgroundColor ? 'fit-content' : 'auto'};
        cursor: pointer;
        padding: 4px 8px;
        border: ${$backgroundColor == '#FFFFFF' ? '1px solid #999999' : ''};
        margin-right: 4px;
      `
    case BadgeVariant.VEHICLE:
      return css`
        background-color: ${$backgroundColor};
        color: ${$textColor};
        padding: 12px 8px !important;
        font-weight: 500 !important;
        font-size: 10px !important;
        border-radius: 4px;
      `
    default:
      return css`
        background-color: ${({ theme: { colors } }) => colors.primary};
      `
  }
}

const hasChildrenStyles = ({ $hasChildren, $variant }: ContainerProps) =>
  $hasChildren &&
  css`
    height: ${({ $size }: ContainerProps) => `${$size}px`};
    padding: ${({ theme: { layout } }) => layout.spacing(0.5)};
    font-weight: ${$variant === BadgeVariant.TAG ? '400' : '700'};
  `

export const Container = styled.span<ContainerProps>`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: ${({ $size }) => `${$size}px`};
  min-height: ${({ $size }) => `${$size}px`};
  border-radius: ${({ $size }) => `${$size}px`};
  color: #fff;
  line-height: 1;
  ${variantStyles}
  ${hasChildrenStyles}
`
